import {
  RESET_VUEX_SYSTEM_ROLES,
  GET_ALL_ROLES,
  GET_SPECIFIC_ROLE,
  SET_SELECTED_ROLES,
  GET_RAMAIS,
  SET_SELECTED_RAMAIS_RELATORIO_PABX,
  SET_SELECTED_RAMAIS_MONITOR_RAMAIS,
  GET_TAGS,
  SET_SELECTED_TAGS_RELATORIO_PABX,
  SET_SELECTED_TAGS_PESQUISA_SATISFACAO,
  GET_FILAS,
  GET_DEPARTAMENTOS,
  GET_OPERADORES,
  SET_SELECTED_DEPARTAMENTOS,
  SET_SELECTED_FILAS,
  SET_SELECTED_OPERADORES,
  GET_CONFERENCIAS,
  SET_SELECTED_CONFERENCIAS,
  GET_PESQUISAS_SATISFACAO,
  SET_SELECTED_PESQUISAS_SATISFACAO,
  ADD_PERMISSION_ID,
  DELETE_PERMISSION_ID,
  CHANGE_ALL_PERMISSION_ID,
} from "./mutation-types";

import {
  rolesStateArrayPermissions,
  rolesStatePermissions,
} from "../_utils/rolesStateKeys";

export default {
  [RESET_VUEX_SYSTEM_ROLES]: (state) => {
    rolesStateArrayPermissions.forEach((arraySelectedPermission) => {
      state[`${arraySelectedPermission}`].splice(0);
    });

    rolesStatePermissions.forEach((statePermission) => {
      state[`${statePermission}`] = false;
    });

    state.step = 1;
  },
  [GET_ALL_ROLES]: (state, roles) => {
    state.roles = roles;
  },

  [GET_SPECIFIC_ROLE]: (state, role) => {
    state.role = role;
  },

  [SET_SELECTED_ROLES]: (state, selectedRoles) => {
    state.selectedRoles = selectedRoles;
  },

  [GET_RAMAIS]: (state, ramais) => {
    state.ramais = ramais;
  },

  [SET_SELECTED_RAMAIS_MONITOR_RAMAIS]: (state, arrayIdRamais) => {
    state.selectedRamaisMonitorRamais = arrayIdRamais;
  },

  [SET_SELECTED_RAMAIS_RELATORIO_PABX]: (state, arrayIdRamais) => {
    state.selectedRamaisRelatoriosPABX = arrayIdRamais;
  },

  [GET_TAGS]: (state, tags) => {
    state.tags = tags;
  },

  [SET_SELECTED_TAGS_RELATORIO_PABX]: (state, arrayIdTags) => {
    state.selectedTagsRelatoriosPABX = arrayIdTags;
  },

  [SET_SELECTED_TAGS_PESQUISA_SATISFACAO]: (state, arrayIdTags) => {
    state.selectedTagsPesquisaSatisfacao = arrayIdTags;
  },

  [GET_CONFERENCIAS]: (state, conferencias) => {
    state.conferencias = conferencias;
  },

  [SET_SELECTED_CONFERENCIAS]: (state, arrayIdsConferencias) => {
    state.selectedConferencias = arrayIdsConferencias;
  },

  [GET_FILAS]: (state, filas) => {
    state.filas = filas;
  },

  [SET_SELECTED_FILAS]: (state, arrayIdsFilas) => {
    state.selectedFilas = arrayIdsFilas;
  },

  [GET_DEPARTAMENTOS]: (state, departamentos) => {
    state.departamentos = departamentos;
  },

  [SET_SELECTED_DEPARTAMENTOS]: (state, arrayIdsDepartamentos) => {
    state.selectedDepartamentos = arrayIdsDepartamentos;
  },
  
  [GET_OPERADORES]: (state, operadores) => {
    state.operadores = operadores;
  },

  [SET_SELECTED_OPERADORES]: (state, arrayIdsOperadores) => {
    state.selectedOperadores = arrayIdsOperadores;
  },

  [GET_PESQUISAS_SATISFACAO]: (state, pesquisasSatisfacao) => {
    state.pesquisasSatisfacao = pesquisasSatisfacao;
  },

  [SET_SELECTED_PESQUISAS_SATISFACAO]: (state, arrayIdsPesquisasSatisfacao) => {
    state.selectedPesquisasSatisfacao = arrayIdsPesquisasSatisfacao;
  },

  // ==================

  [CHANGE_ALL_PERMISSION_ID]: (state, permission) => {
    state.selectedPermissions.splice(0);
    state.selectedPermissions.push(...permission);
  },
  [ADD_PERMISSION_ID]: (state, permission) => {
    let key = state.selectedPermissions.indexOf(permission);
    if (key == -1) {
      state.selectedPermissions.push(permission);
    }
  },

  [DELETE_PERMISSION_ID]: (state, permission) => {
    let key = state.selectedPermissions.indexOf(permission);
    state.selectedPermissions.splice(key, 1);
  },
};
